import {EdiAcHd} from './EdiAcHd';
import {EdiAcDetail} from './EdiAcDetail';
import {RevisionHistory} from './RevisionHistory';

export class AcctHistHd  {
    invoiceNo: string = '';
    billName: string = '';
    postDate: string | null = null;
    invoiceDate: string | null = null;
    dueDate: string | null = null;
    confirmDate: string | null = null;
    confirmActionDate: string | null = null;
    amount: number = 0;
    advRecAmount: number = 0;
    paidAmt: number = 0;
    historyHDList: EdiAcHd[] = [];
    historyDetaillAllList: EdiAcDetail[] = [];
    historyDetailList: EdiAcDetail[] = [];
    revisionHistList: RevisionHistory[] = [];
    // 250724.inhyung.issue#2576 add data field
    agentRefNo: string = '';
    refNo: string = '';
    mblNo: string = '';
    hblNo: string = '';
    createdDate: string | null = null;
    updatedDate: string | null = null;

    fromDate: string | null = null;
    toDate: string | null = null;
    reportType: string = '';
}

export enum AcctHistoryType {
    DInvoHistory = 'DInvoHistory',
    DApHistory = 'DApHistory',
    DCrDbHistory = 'DCrDbHistory',
    InvoHistory = 'InvoHistory',
    ApHistory = 'ApHistory',
    CrDbHistory = 'CrDbHistory'
}
